import { useParams } from '@rocketlane/rocket-router';
import { useGetCompanyById } from 'queries/company';

export const useCompanyFromUrl = () => {
  const { accountId: accountIdParam } = useParams();
  const accountId = parseInt(accountIdParam ?? '-1', 10);

  return useGetCompanyById(accountId);
};
